// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2yqNk","label":"LabeledBox_label__2M_w1"};